export default __webpack_public_path__ + "static/media/artemis_logo_dark.e402612a.png";